(function () {
  'use strict';

  function updateCartBar(bar, count) {
    if (!bar) return;
    var countEl = bar.querySelector('[data-cart-count]');
    if (countEl) countEl.textContent = count;
    if (count > 0) {
      bar.hidden = false;
    } else {
      bar.hidden = true;
    }
  }

  function showToast(toast, message, isError) {
    if (!toast) return;
    toast.textContent = message;
    toast.hidden = false;
    toast.classList.toggle('lp3f2-toast--error', !!isError);
    requestAnimationFrame(function () {
      toast.classList.add('is-visible');
    });
    clearTimeout(toast._lp3f2Timeout);
    toast._lp3f2Timeout = setTimeout(function () {
      toast.classList.remove('is-visible');
      setTimeout(function () {
        toast.hidden = true;
      }, 200);
    }, 2500);
  }

  function refreshCartCount(bar) {
    fetch('/cart.js')
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        updateCartBar(bar, cart.item_count);
      })
      .catch(function () {});
  }

  function init(root) {
    if (!root || root._lp3f2Initialized) return;
    root._lp3f2Initialized = true;

    var bar = document.querySelector('[data-cart-bar]');
    var toast = document.querySelector('[data-toast]');

    refreshCartCount(bar);

    root.querySelectorAll('[data-product-card]').forEach(function (card) {
      var input = card.querySelector('[data-qty-input]');
      var addBtn = card.querySelector('[data-add-to-cart]');

      card.querySelectorAll('[data-step]').forEach(function (btn) {
        btn.addEventListener('click', function () {
          var current = parseInt(input.value, 10) || 1;
          var min = parseInt(input.min, 10) || 1;
          var max = parseInt(input.max, 10) || 20;
          if (btn.dataset.step === 'increase') {
            current = Math.min(max, current + 1);
          } else {
            current = Math.max(min, current - 1);
          }
          input.value = current;
        });
      });

      input.addEventListener('change', function () {
        var min = parseInt(input.min, 10) || 1;
        var max = parseInt(input.max, 10) || 20;
        var value = parseInt(input.value, 10) || min;
        input.value = Math.min(max, Math.max(min, value));
      });

      addBtn.addEventListener('click', function () {
        var variantId = addBtn.dataset.variantId;
        var quantity = parseInt(input.value, 10) || 1;
        var label = addBtn.querySelector('[data-btn-label]');
        var originalText = label ? label.textContent : '';

        addBtn.disabled = true;
        if (label) label.textContent = 'Wird hinzugefügt...';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({
            items: [{ id: variantId, quantity: quantity }]
          })
        })
          .then(function (res) {
            if (!res.ok) {
              return res.json().then(function (err) {
                throw new Error(err.description || 'Fehler beim Hinzufügen');
              });
            }
            return res.json();
          })
          .then(function () {
            addBtn.classList.add('is-success');
            if (label) label.textContent = 'Hinzugefügt ✓';
            showToast(toast, 'Zum Warenkorb hinzugefügt', false);
            refreshCartCount(bar);
            setTimeout(function () {
              addBtn.classList.remove('is-success');
              addBtn.disabled = false;
              if (label) label.textContent = originalText;
            }, 1500);
          })
          .catch(function (err) {
            showToast(toast, err.message || 'Fehler beim Hinzufügen', true);
            addBtn.disabled = false;
            if (label) label.textContent = originalText;
          });
      });
    });
  }

  window.Lp3f2 = { init: init };
})();
